import { createSelector } from '@ngrx/store';
import { OfferStatus } from 'src/app/shared/models/enums/offers.enum';
import * as fromFeature from '../reducers';
import { DealDetailsState } from '../reducers/deal-details.reducer';

export const getDealDetailsState = createSelector(
    fromFeature.recruitingFeature,
    (state: fromFeature.RecruitingRootStoreState) => state.dealDetails
);

export const selectDealsDetailsOffer = createSelector(getDealDetailsState, (state: DealDetailsState) => state.details);

export const selectDealsDetailsOfferMarginDifferences = createSelector(
    getDealDetailsState,
    (state: DealDetailsState) => state.marginDifferences
);

export const selectDealsNotes = createSelector(getDealDetailsState, (state: DealDetailsState) => state.notes);

export const selectCanModify = createSelector(
    getDealDetailsState,
    (state: DealDetailsState) =>
        state.details &&
        state.details.statusId !== OfferStatus.Declined &&
        state.details.statusId !== OfferStatus.Rescinded
);

export const selectAttachments = createSelector(getDealDetailsState, (state: DealDetailsState) => state.attachments);

export const selectDeclineReasons = createSelector(
    getDealDetailsState,
    (state: DealDetailsState) => state.declineReasons
);

export const selectVendorSearchResults = createSelector(
    getDealDetailsState,
    (state: DealDetailsState) => state.vendorSearch
);

export const selectFacilitySearchResults = createSelector(
    getDealDetailsState,
    (state: DealDetailsState) => state.facilitySearch
);
